<template>
  <v-container>
    <legend>
      <div class="text-body-1 font-weight-bold">Informations demandeur</div>
    </legend>
    <v-divider />

    <v-card-text>
      <v-row class="pl-5">
        <v-col cols="5" sm="2" class="font-weight-bold pa-0 pt-5">
          Date de la commande
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="tsCommande"
                prepend-icon="event"
                readonly
                style="width:200px"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="tsCommande"
              :min="minDate"
              color="accent"
              @input="menu = false"
              @change="majDate()"
            />
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="pl-5">
        <v-col cols="5" sm="2" class="font-weight-bold pa-0">
          Type de client
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          {{ typesClientJDE.get(agentConnecteInfosJDE.typeClient) }}
        </v-col>
      </v-row>

      <v-row class="pl-5">
        <v-col cols="5" sm="2" class="font-weight-bold pa-0">
          No de client
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          {{ agentConnecteInfosJDE.noClientJDE }}
        </v-col>
      </v-row>

      <v-row class="pl-5">
        <v-col cols="5" sm="2" class="font-weight-bold pa-0">
          Nom du client
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          {{ agentConnecteInfosJDE.nom }}
        </v-col>
      </v-row>

      <v-row class="pl-5">
        <v-col cols="5" sm="2" class="font-weight-bold pa-0">
          Adresse
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          {{ agentConnecteInfosJDE.adresse }}
          {{ agentConnecteInfosJDE.ville }}
          {{ agentConnecteInfosJDE.codePostal }}
        </v-col>
      </v-row>

      <v-row
        v-if="agentConnecteInfosJDE.noTelephoneBureau1 != null"
        class="pl-5"
      >
        <v-col cols="5" sm="2" class="font-weight-bold pa-0">
          Téléphone bureau 1
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          {{ agentConnecteInfosJDE.noTelephoneBureau1 }}
        </v-col>
      </v-row>

      <v-row
        v-if="agentConnecteInfosJDE.noTelephoneBureau2 != null"
        class="pl-5"
      >
        <v-col cols="5" sm="2" class="font-weight-bold pa-0">
          Téléphone bureau 2
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          {{ agentConnecteInfosJDE.noTelephoneBureau2 }}
        </v-col>
      </v-row>

      <v-row class="pl-5">
        <v-col cols="5" sm="2" class="font-weight-bold pa-0">
          Téléphone autre
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          {{ agentConnecteInfosJDE.noTelephoneAutre }}
        </v-col>
      </v-row>

      <v-row class="pl-5">
        <v-col cols="5" sm="2" class="font-weight-bold pa-0 pt-6">
          Nom du contact
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          <v-text-field
            v-model.trim="nomContact"
            :error-messages="nomContactErrors"
            :disabled="sending"
            clearable
            style="width:300px"
            maxlength="128"
            counter="128"
            @change="submit()"
            @input="$v.nomContact.$touch()"
            @blur="$v.nomContact.$touch()"
          />
        </v-col>
      </v-row>

      <v-row class="pl-5">
        <v-col cols="5" sm="2" class="font-weight-bold pa-0 pt-6">
          Courriel du contact
        </v-col>
        <v-col cols="5" sm="4" class="pa-0">
          <v-text-field
            v-model="courrielContact"
            :error-messages="courrielContactErrors"
            :disabled="sending"
            clearable
            style="width:300px"
            maxlength="128"
            counter="128"
            @change="submit"
            @input="$v.courrielContact.$touch()"
            @blur="$v.courrielContact.$touch()"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-container>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength,
  numeric
} from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { typesClientJDE } from '@/plugins/enums'
import moment from 'moment'
export default {
  name: 'StepDemandeur',
  mixins: [validationMixin],
  data() {
    return {
      nomContact: null,
      courrielContact: null,
      tsCommande: this.$fmtTsEnDate(new Date()),
      menu: false,
      sending: false
    }
  },

  computed: {
    agentConnecte: function() {
      return this.$store.getters.agentConnecte
    },
    agentConnecteInfosJDE: function() {
      return this.$store.getters.agentConnecteInfosJDE
    },
    demandeur: function() {
      return this.$store.getters.commande.demandeur
    },
    minDate() {
      return this.$fmtTsEnDate(new Date())
    },
    typesClientJDE: function() {
      return typesClientJDE
    },
    courrielContactErrors() {
      const errors = []
      if (!this.$v.courrielContact.$dirty) return errors
      !this.$v.courrielContact.required && errors.push('Champ obligatoire')
      !this.$v.courrielContact.email &&
        errors.push("Le format n'est pas valide")
      return errors
    },
    nomContactErrors() {
      const errors = []
      if (!this.$v.nomContact.$dirty) return errors
      !this.$v.nomContact.required && errors.push(this.$t('msg_obligatoire'))
      return errors
    }
  },

  validations: {
    nomContact: {
      required
    },
    courrielContact: {
      required,
      email
    }
  },

  watch: {
    '$store.getters.commande.destinataireClient': function(destinataireClient) {
      console.log('Dans le watch du destinataireClient')

      // Si on provient d'une copie ou transmettre un brouillon
      if (this.$route.params.idCommande != null) {
        this.tsCommande = moment(
          this.$store.getters.commande.tsCommande
        ).format('YYYY-MM-DD')

        this.nomContact = this.$store.getters.commande.nomContact
        this.courrielContact = this.$store.getters.commande.courrielContact
      }

      // Si on vient d'un fichier excel
      if (
        this.$store.getters.commande.tsCommande != null &&
        this.$store.getters.commande.commandeExcel == true
      ) {
        this.tsCommande = moment(
          this.$store.getters.commande.tsCommande
        ).format('YYYY-MM-DD')

        this.nomContact = this.$store.getters.commande.nomContact
        this.courrielContact = this.$store.getters.commande.courrielContact
      }

      this.majDate()
    },

    '$store.getters.commande.demandeur': function(demandeur) {
      console.log('Dans le watch du demandeur')

      if (this.$store.getters.commande.demandeur.noClientJDE == null) {
        this.$store.getters.commande.demandeur = this.agentConnecte
      }

      //this.nomContact = this.$store.getters.commande.demandeur.nomContact
      //this.courrielContact = this.$store.getters.commande.demandeur.courrielContact
      this.majDate()
    }
  },

  beforeMount() {
    console.log('Dans le beforeMount de step - demandeur')
    this.nomContact = this.$store.getters.agentConnecte.nomContact
    this.courrielContact = this.$store.getters.agentConnecte.courrielContact
  },

  methods: {
    majDate() {
      console.log(
        'majDate ' +
          this.tsCommande +
          ' commande.tsCommande: ' +
          this.$store.getters.commande.tsCommande +
          ' Excel: ' +
          this.$store.getters.commande.commandeExcel
      )

      //if (this.$store.getters.commande.tsCommande != null) {
      // this.tsCommande = moment(
      //   this.$store.getters.commande.tsCommande
      // ).format('YYYY-MM-DD')
      //} else {
      this.$store.getters.commande.tsCommande = this.tsCommande
      //}
    },
    submit() {
      this.$store.getters.commande.nomContact = this.nomContact
      this.$store.getters.commande.courrielContact = this.courrielContact
    }
  }
}
</script>

<style scoped>
fieldset {
  display: block;
  margin-left: 0px;
  margin-right: 0px;
  padding-left: em;
  border: none;
}
legend {
  margin-left: 20px;
}
div {
  font-size: 13px;
}
.theme--light.v-divider {
  border-color: grey !important;
}
</style>
